import React from 'react';
import 'echarts/theme/v5';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AppSettingsProvider } from './contexts/AppSettingsContext';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppSettingsProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </AppSettingsProvider>
    </AuthProvider>
  </React.StrictMode>
);
//temp for forceful redeploy
